export default __webpack_public_path__ + "static/bandaidComputer-80b15ca79f9b2397879999e65b99792b.svg";